module.exports = __webpack_public_path__ + "static/media/mastercard.c2520d73.svg";